import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";

interface AuthState {
  isAuthInitialized: boolean;
  isAuthenticated: boolean;
  roles: Array<string>;
  access_token: string;
  subject: string;
}
interface IrefreshAccessToken {
  roles: Array<string>;
  access_token: string;
}
const initialState: AuthState = {
  isAuthenticated: false,
  isAuthInitialized: false,
  roles: [],
  access_token: "",
  subject: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authInitialized: (state, action: PayloadAction<boolean>) => {
      state.isAuthInitialized = action.payload;
    },
    authenticate: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setOrUpdateTokenPayloadInfo: (
      state,
      action: PayloadAction<IrefreshAccessToken>
    ) => {
      state.roles = action.payload.roles;
      state.access_token = action.payload.access_token;
      state.subject = JSON.parse(
        atob(action.payload.access_token.split(".")[1])
      ).sub;
    },
  },
});

export const { authenticate, authInitialized, setOrUpdateTokenPayloadInfo } =
  authSlice.actions;
export default authSlice.reducer;
